// extracted by mini-css-extract-plugin
export default {"toast":"MainToast_toast__zWq6s","toastBody":"MainToast_toastBody__a6lof"};